import React from 'react';
import { GENERIC_RECORD_NOTE } from '../../../constants/abdmCopy';
import { maskAbhaAddress, maskAbhaNumber } from '../../../services/api/abhaProfile';

// An "@" means the value is an ABHA address, anything else an ABHA number.
const maskAbhaValue = (value) => (String(value).includes('@') ? maskAbhaAddress(String(value)) : maskAbhaNumber(value));

// The dump is shown as-is except the patient's contact and identity details: the mobile and
// birth date are left out, and the ABHA number / address are masked.
function withoutPatientDetails(parsedSummary) {
  const patient = parsedSummary?.patient;
  if (!patient || typeof patient !== 'object') return parsedSummary;
  const { mobile: _mobile, birth_date: _birthDate, ...rest } = patient;
  ['abha_number', 'abha_address'].forEach((key) => {
    if (rest[key]) rest[key] = maskAbhaValue(rest[key]);
  });
  return { ...parsedSummary, patient: rest };
}

/**
 * GenericRenderer — fallback for any HI type without a dedicated renderer
 * (an "Unknown" hi_type the backend couldn't classify). Never a blank screen.
 *
 * Props:
 *   parsedSummary {object} — the parsed FHIR summary (snake_case, backend shape)
 */
export default function GenericRenderer({ parsedSummary, isDark }) {
  return (
    <div>
      <p style={{ fontSize: 12, color: isDark ? '#9ca3af' : '#6b7280', marginBottom: 8 }}>
        {GENERIC_RECORD_NOTE}
      </p>
      <pre style={{
        fontSize: 12,
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        background: isDark ? '#0f172a' : '#f8fafc',
        color: isDark ? '#e2e8f0' : '#1e293b',
        border: `1px solid ${isDark ? 'rgba(255,255,255,0.08)' : '#e5e7eb'}`,
        borderRadius: 8,
        padding: 12,
        margin: 0,
      }}>
        {JSON.stringify(withoutPatientDetails(parsedSummary), null, 2)}
      </pre>
    </div>
  );
}
